module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-report-4.4673dfc1.svg";